import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import {
  faLayerGroup,
  faDoNotEnter,
  faTrash,
  faFileMedical,
  faMap,
  faSpinnerThird,
  faExclamationCircle,
  faPencil,
  faArrows,
  faDrawSquare,
  faChevronDown,
  faSave,
  faFileImport,
  faAnchor,
  faBracketsCurly,
  faSitemap,
  faStream,
  faCog,
  faGripLinesVertical,
  faFolderOpen,
  faCheckCircle,
  faFilter,
  faFilePdf,
  faImage,
} from '@fortawesome/pro-duotone-svg-icons';

const initIconLibrary = () =>
  library.add(
    faDoNotEnter,
    faTrash,
    faFileMedical,
    faMap,
    faSpinnerThird,
    faExclamationCircle,
    faPencil,
    faPlus,
    faArrows,
    faDrawSquare,
    faChevronDown,
    faSave,
    faFileImport,
    faAnchor,
    faLayerGroup,
    faBracketsCurly,
    faSitemap,
    faStream,
    faCog,
    faGripLinesVertical,
    faFolderOpen,
    faCheckCircle,
    faFilter,
    faFilePdf,
    faImage,
  );

export default initIconLibrary;
